import React from "react";

interface SidebarChipProps {
  children: React.ReactNode;
  ariaLabel?: string;
  className?: string;
}

const SidebarChip = React.memo<SidebarChipProps>(({
  children,
  ariaLabel,
  className = ""
}) => {
  return (
    <span
      className={`sidebar-chip inline-flex h-[20px] min-w-[28px] items-center justify-center rounded-full bg-[#D4D4D8]/40 px-[8px] text-[12px] text-[#71717A] group-data-[selected=true]:bg-[#D4D4D8]/40 group-data-[selected=true]:text-white ${className}`}
      aria-label={ariaLabel}
    >
      {children}
    </span>
  );
});

SidebarChip.displayName = "SidebarChip";

export default SidebarChip; 
